export default __webpack_public_path__ + "static/media/ferrothorn_s.bbd87eb9.png";